export default __webpack_public_path__ + "static/media/logo-dark.552c0e99.png";